module.exports = __webpack_public_path__ + "img/48000.a1e99d82.jpg";